import { get, post } from "api/apiBridges/httpBridge";
import { useEffect, useState } from "react";
import Button from '@mui/material/Button';
import { modal_style } from "styles/modal_style"
import { Email, ExpandLess, ExpandMore } from "@mui/icons-material";
import { colors } from "styles/colors";
import {Typography, Avatar, Collapse, List, ListItemButton, ListItemText, Switch, Select, MenuItem, Dialog,} from "@mui/material";
import avatarTest from '../../images/others/avatar.png';
import { TextInput, CheckList, NumInput, TextFeature, SelectAdmin}  from "./LittleComponents";
import _ from "lodash";
import { useSelector } from "react-redux";
import { loginSelector } from "store/slices/loginSlice";
import usePreventDoubleClick from "components/AntiDBC";
import { useLocalNotifications } from "components/Events";
import { ShowModal } from "components/Modal";
import Loading from 'components/Load';
import { MuiTelInput, matchIsValidTel } from 'mui-tel-input';

export default function ClientWorker({data, onClose, setChanged}){
  
  const [$data, $setdata] = useState(data || {});
  const [login, setLogin] = useState(undefined);
  const [$roles, $setroles] = useState([]);
  const [loading, setLoading] = useState(true);

  const { user_id, rules } = useSelector(
    loginSelector
  );
  const preventDoubleClick = usePreventDoubleClick();

  const { showNotification } = useLocalNotifications();

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const responseRoles = await get('ClientsRoles/getClientIdRoles', {cid:user_id});
        let res = []
        if (responseRoles){
        responseRoles.map((el) => {
            let rules = []
            el.rules.map((rule) => {rules.push({id:rule, active:true})})
            res.push({id:el.id, company_id:el.company_id, title:el.title, rules})
        })
        }
        $setroles(res);

        if ((rules.includes('company.show_login') || rules.includes("admin")) && data.id) {
          const meslogin = await get('auth/getLogin', {uid:user_id, sub_id: data.id});
          if (meslogin.message) {
            setLogin(meslogin.message)
          }
        }

      } catch (err) {
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []); 

  const setVal = (val, path) => {
    const currentValue = _.get($data, path);
    if (currentValue === val) return; 

    const newData = _.cloneDeep($data);
    _.set(newData, path, val);
    $setdata(newData);

    if (setChanged) setChanged(true); 
  }



  const newClick = async (e) => {
    try {
      console.log($data.mobile_number)
      let newUser = await post("Registration/addClientsWorker", {
          userInfo: {
              client_id: user_id,
              fio:$data.fio, 
              email:$data.email, 
              mobile_number: $data.mobile_number,
              rules: $data.rules || [],
              data:""
          },
          authinfo:{
              login: $data.mobile_number,
              password: undefined
          },
          user_id
      })
      if (data?.add) {data.add(newUser)}
      onClose()

    } catch (e) {
      console.error(e);
      showNotification({ id: 'errEx', type: 'error', message: 'Ошибка при сохранении' });
    }
  };

  const editClick = async (e) => {
    let user = await post("ClientsWorkers/update", {
      id: data.id,
      fio:$data.fio, 
      email:$data.email, 
      mobile_number: $data.mobile_number,
      rules: $data.rules || []
    })
    if (data.update) {data.update(user)}
    onClose()
  };
  
  const delWorker = async () => {
    ShowModal('Удалить переменную', 
    <div>Вы уверены, что хотите удалить сотрудника?</div>, 
    async () => {
        try {
          await post("ClientsWorkers/delete", {id: data.id})
          if (data.del) {data.del(data.id)}
          onClose()
        }
        catch (err) {}
        finally {}
        
    });
  }

  if (loading) return (<Loading />);

  return (
    <div>

      <div style = {{padding: '10px', display: "flex", flexDirection: "column"}}>

        <div>
          <div style={{marginTop: "10px"}}>
            {$data.id && <Button variant="contained" onClick={preventDoubleClick(() => post("Registration/regenClientWorkerPass", {user_id:user_id, sub_id: data.id}).then(() => showNotification({id:'successRegenPass', type:'success', message:'Новый пароль отправлен'})), 1000)} sx={{textTransform: 'none', fontWeight: 'bold', backgroundColor:'#078376'}}>Сгенерировать новый пароль</Button>}
          </div>
          
          <div style={{marginTop: "10px", width: "60%"}}>
            {$data.id && login && <TextFeature title="Логин" val={login} />}
          </div>

          <div style={{marginTop: "10px", width: "60%"}}>
            <TextInput title="ФИО" val={$data?.fio} onChange={(el) => setVal(el, "fio")} />
          </div>
          
          <div style={{marginTop: "10px", width: "56%"}}>
            <div style={{display:'flex', flexDirection:'column'}}>
                <Typography variant="body1" sx={{fontSize:'14px', marginBottom:'4px'}}>Телефон</Typography>
                <MuiTelInput 
                value={$data?.mobile_number || ''} 
                onChange={(val) => setVal(val, "mobile_number")}
                defaultCountry="RU"
                variant="standard"
                forceCallingCode
                langOfCountryName="ru"
                inputProps={{ maxLength: 20 }}
                MenuProps={{
                  sx: {
                    '& .MuiMenu-paper': { backgroundColor: '#ffffff', borderRadius: '15px', marginTop: '8px' },
                    '& .MuiTelInput-Flag': { display: 'none' },
                    '& .MuiMenuItem-root': { paddingLeft: '12px', minHeight: 'auto' },
                    '& .MuiTypography-root': { marginLeft: '-45px' }
                  }
                }}
                sx={{
                  width: '100%',
                  "& .MuiInput-root": {
                    backgroundColor: "transparent",
                    marginTop: '4px',
                    "&:hover:not(.Mui-disabled):before": {
                      borderBottom: `2px solid ${colors.elements || '#078376'}`,
                    },
                    "&:after": {
                      borderBottom: `2px solid ${colors.elements || '#078376'}`,
                    }
                  },
                  '& .MuiTelInput-IconButton': {
                    padding: '0 8px 0 0',
                    borderRadius: 0,
                    '&::after': {
                      content: '"◉"',
                      fontSize: '18px',
                      color: '#078376',
                    }
                  },
                  '& .MuiTelInput-Flag': { display: 'none' },
                  "& .MuiInputBase-input": {
                    fontWeight: '500',
                    fontSize: '15px',
                    padding: '8px 0',
                  }
                }}
              />
            </div>
          </div>
          
          <div style={{marginTop: "10px", width: "60%"}}>
            <TextInput title="Почта" val={$data.email} onChange={(el) => setVal(el, "email")} />
          </div>
          <div style={{marginTop: "10px", width: "60%"}}>
            <CheckList title={"Роль"} varlist={$roles} selected={$data.rules || []} onChange={(el) => setVal(el, "roles")} />
          </div>
        </div>
        
        <div style={{marginTop: "10px"}}>
          {$data.id && $data.status !== '0' &&
            <> 
              <Button variant="contained" onClick={preventDoubleClick(delWorker, 1000)} sx={{textTransform: 'none', fontWeight: 'bold', backgroundColor:'#078376'}}>Удалить сотрудника</Button>
            </>
          }
        </div>
      </div>    
      
      <div style={{ display: 'flex', justifyContent: 'flex-end', margin: '5px' }}>
        <Button 
          onClick={preventDoubleClick($data.id ? editClick : (e) => newClick(e), 1000)} 
          variant="contained" 
          sx={{ textTransform: 'none', backgroundColor: colors.elements, fontWeight: 'bold' }}
        >
          {$data.id ? "Сохранить" : "Добавить"}
        </Button>
      </div>
    </div>
  );
}